import React from 'react'
import { Form } from 'formik'
import { makeStyles } from '@material-ui/core/styles'
import { Box } from '@material-ui/core'
import { SEARCH_BUTTON_ID } from 'utils/contants'
import DisplayLimitSelect from 'componentsHsc/OverlaySearch/DisplayLimitSelect'
import { DisplayLimitOptionInfo, Option } from 'pages/MCAXS010/formConfig'
import { useSelector } from 'react-redux'
import { RootState } from 'reducers'

const useStyles = makeStyles({
  root: {
    fontSize: '2.1rem !important',
    height: '64px',
    width: '362px',
  },
  hidenButton: {
    display: 'none',
  },
  displaylimitSelect: {
    width: '200px',
    padding: '2px',
    borderRadius: '3px',
    fontSize: '14px',
  },
  centeredButton: {
    position: 'relative',
    left: '50%',
    transform: 'translateX(-60%)',
  },
  displaylimitposition: {
    position: 'absolute',
    left: '50%',
    marginLeft: '160px',
  },
  displayLimitHidden: {
    display: 'none',
  },
  mysearchposition: {
    marginTop: '15px',
    marginBottom: '-20px',
  },
})

function onKeyDown(keyEvent: any) {
  if (
    (keyEvent.charCode || keyEvent.keyCode) === 13 &&
    keyEvent.target.type !== 'textarea'
  ) {
    keyEvent.preventDefault()
    return false
  }
}

interface Props {
  onSubmitButtonClick: (type: string) => void
  enableDisplayLimit?: boolean
  displayLimit?: Option
  displayLimitOption?: DisplayLimitOptionInfo[]
  serviceMode?: string
}

const TabItem: React.FC<Props> = ({
  children,
  onSubmitButtonClick,
  enableDisplayLimit = false,
  displayLimit = { label: '', value: '' },
  displayLimitOption = [],
  serviceMode = '0'
}) => {
  const classes = useStyles()
  const {open} = useSelector((state: RootState) => state.advancedSearch)

  return (
    <Form onKeyDown={onKeyDown}>
      {children}
      <Box display='flex' justifyContent='center'>
        <Box p={1} zIndex={2}>
          <button
            id={SEARCH_BUTTON_ID}
            type='submit'
            className={`${classes.root} btn high on-icon icon-search ${classes.centeredButton}`}
            onClick={() => onSubmitButtonClick('search')}>
            検索
          </button>
        </Box>
        {enableDisplayLimit && (
          <React.Fragment>
            <div className={`${classes.displaylimitposition} ${open ? '' : classes.displayLimitHidden}`}>
              <Box p={1} zIndex={2}>
                <DisplayLimitSelect
                  className={classes.displaylimitSelect}
                  displayLimit={displayLimit}
                  displayLimitOption={displayLimitOption}
                />
              </Box>
            </div>
          </React.Fragment>
        )}
      </Box>
      <Box display='flex' justifyContent='flex-end'>
        <div className={classes.mysearchposition}>
          <Box p={1} m={-6} pl={70} pr={5} zIndex={1}>
            {serviceMode !== '1' && (
              <button
                type='submit'
                className={`btn`}
                onClick={() => onSubmitButtonClick('save')}>
                MY検索に保存
              </button>
            )}
            <button
              id='searhConditionReset'
              type='reset'
              className={classes.hidenButton}
            />
          </Box>
        </div>
      </Box>
    </Form>
  )
}

export default TabItem
